"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
var React = __importStar(require("react"));
var colors_1 = require("../../../constants/colors");
var icons_1 = require("../../../constants/icons");
var molecules_1 = require("../../molecules");
var pagination_constants_1 = require("./pagination.constants");
var pagination_utils_1 = require("./pagination.utils");
var Pagination = function (_a) {
    var count = _a.count, currentPage = _a.currentPage, onChange = _a.onChange, id = _a.id, eventCallback = _a.eventCallback;
    var items = pagination_utils_1.handlePagination({
        count: count,
        currentPage: currentPage,
        onChange: onChange,
        id: id,
        eventCallback: eventCallback,
    }).items;
    return (React.createElement("div", { className: 'tw-flex tw-list-none', "data-testid": "pagination-" + id }, items.map(function (_a, index) {
        var page = _a.page, type = _a.type, selected = _a.selected, disabled = _a.disabled, item = __rest(_a, ["page", "type", "selected", "disabled"]);
        var children = null;
        if (type === pagination_constants_1.PAGE_TYPES.START_ELLIPSIS || type === pagination_constants_1.PAGE_TYPES.END_ELLIPSIS)
            children = (React.createElement("button", { className: "f-12-400 tw-w-9 tw-h-9 tw-border-y-[1px] tw-border-DIVIDER_GRAY", "data-testid": "pagination-button-ellipsis-" + id }, "..."));
        else if (type === pagination_constants_1.PAGE_TYPES.PAGE)
            children = (React.createElement("button", __assign({}, item, { className: "f-12-400 tw-w-9 tw-h-9 tw-border-y-[1px] tw-border-DIVIDER_GRAY hover:tw-bg-ZAMP_SECONDARY " + (selected && 'tw-bg-ZAMP_SECONDARY'), "data-testid": "pagination-button-page-" + page + "-" + id }), page));
        else
            children = (React.createElement("button", __assign({ className: "f-12-400 tw-flex tw-gap-2 tw-items-center tw-h-9 tw-px-4 tw-border-[1px] tw-border-DIVIDER_GRAY  " + (type === pagination_constants_1.PAGE_TYPES.PREV ? 'tw-rounded-l-full' : '!tw-rounded-r-full') + " " + (disabled ? 'tw-text-TEXT_TERTIARY tw-cursor-default' : 'tw-text-TEXT_PRIMARY hover:tw-bg-ZAMP_SECONDARY'), disabled: disabled }, item, { "data-testid": "pagination-button-page-prev-next-" + type + "-" + id }),
                type === pagination_constants_1.PAGE_TYPES.PREV && (React.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-left', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, fillColor: 'none', width: 16, height: 16, color: disabled ? colors_1.COLORS.TEXT_TERTIARY : colors_1.COLORS.TEXT_PRIMARY })),
                type === pagination_constants_1.PAGE_TYPES.PREV ? 'Prev' : 'Next',
                type === pagination_constants_1.PAGE_TYPES.NEXT && (React.createElement(molecules_1.SvgSpriteLoader, { id: 'chevron-right', iconCategory: icons_1.ICON_SPRITE_TYPES.ARROWS, fillColor: 'none', width: 16, height: 16, color: disabled ? colors_1.COLORS.TEXT_TERTIARY : colors_1.COLORS.TEXT_PRIMARY }))));
        return (React.createElement("li", { key: index, "data-testid": "pagination-li-" + index + "-" + id }, children));
    })));
};
exports.Pagination = Pagination;
